var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showPlaceHolder ? _c("div", { style: _vm.stylePlaceHolder }) : _vm._e(),
    _c(
      "div",
      {
        ref: "scroll-affix",
        class: _vm.showPlaceHolder
          ? "scroll-affix-container"
          : "scroll-affix-container pd0",
        style: _vm.affixStyle,
      },
      [
        _vm._t("default", null, null, {
          affixed: _vm.getAffixed,
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }